import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useReducer, useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { DEPLOY_ACTIONS, DEPLOY_MODE, initialState, reducerStateMap, INSTANT_PREVIEW_VERSION, LOCK_STATUS, INSTANT_PREVIEW_ENV } from './constants';
import { cancelSchedule, deployActionV2, parseDateTime } from './utils';
import ScheduleDialog from './ScheduleDialog';
import Icon from './Icon';
var REVALIDATE_PATH = DEPLOY_ACTIONS.REVALIDATE_PATH,
  PUBLISHING_SCHEDULED = DEPLOY_ACTIONS.PUBLISHING_SCHEDULED,
  PUBLISHING = DEPLOY_ACTIONS.PUBLISHING,
  STAGING = DEPLOY_ACTIONS.STAGING;
function reducer(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, reducerStateMap[action.type], action.payload));
}
function DeployControlsV2(_ref) {
  var _siteInfo$lastPath, _siteInfo$lastPath2, _scheduledPublishing$, _scheduledPublishing$2;
  var getSiteId = _ref.getSiteId,
    siteInfo = _ref.siteInfo,
    loading = _ref.loading,
    setSiteInfo = _ref.setSiteInfo,
    scheduledPublishing = _ref.scheduledPublishing,
    setScheduledPublishing = _ref.setScheduledPublishing;
  var _useReducer = useReducer(reducer, initialState),
    stateClasses = _useReducer[0],
    dispatchStateClasses = _useReducer[1];
  var _useState = useState(''),
    message = _useState[0],
    setMessage = _useState[1];
  var _useState2 = useState(false),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(false),
    isRevalidateOpen = _useState3[0],
    setIsRevalidateOpen = _useState3[1];
  var _useState4 = useState(false),
    isSyncOpen = _useState4[0],
    setIsSyncOpen = _useState4[1];
  var _useState5 = useState(false),
    isPublishOpen = _useState5[0],
    setIsPublishOpen = _useState5[1];
  var _useState6 = useState(false),
    isStageOpen = _useState6[0],
    setIsStageOpen = _useState6[1];
  var _useState7 = useState(0),
    publishStep = _useState7[0],
    setPublishStep = _useState7[1];
  var _useState8 = useState(false),
    publishBtnDisabled = _useState8[0],
    setPublishBtnDisabled = _useState8[1];
  var _useState9 = useState(false),
    webAppBtnDisabled = _useState9[0],
    setWebAppBtnDisabled = _useState9[1];
  var lastPathExecutedAt = (siteInfo === null || siteInfo === void 0 ? void 0 : (_siteInfo$lastPath = siteInfo.lastPath) === null || _siteInfo$lastPath === void 0 ? void 0 : _siteInfo$lastPath.ExecutedAt) || (siteInfo === null || siteInfo === void 0 ? void 0 : (_siteInfo$lastPath2 = siteInfo.lastPath) === null || _siteInfo$lastPath2 === void 0 ? void 0 : _siteInfo$lastPath2.CreatedAt);
  var actions = {
    dispatchStateClasses: dispatchStateClasses,
    setMessage: setMessage,
    setError: setError
  };
  var _useMsal = useMsal(),
    accounts = _useMsal.accounts;
  console.log("scheduledPublishing", scheduledPublishing);
  var getUserEmail = function getUserEmail() {
    if (accounts.length > 0) {
      return accounts[0].username;
    }
    return '';
  };
  var onDeploySuccess = function onDeploySuccess(_ref2) {
    var action = _ref2.action;
    if (action === REVALIDATE_PATH) {
      setSiteInfo(_objectSpread(_objectSpread({}, siteInfo), {}, {
        lastPath: {
          CreatedAt: new Date().toISOString()
        }
      }));
    }
  };
  var runDeployAction = function runDeployAction(action, schedule, onSuccess) {
    return deployActionV2({
      action: action,
      schedule: schedule,
      getSiteId: getSiteId,
      actions: actions,
      getUserEmail: getUserEmail,
      onSuccess: onSuccess,
      onFail: null,
      environment: process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION
    });
  };
  var prependHttp = function prependHttp(url) {
    if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
      url = 'http://' + url;
    }
    return url;
  };
  var handlePublishClick = function handlePublishClick() {
    if (publishStep === 0) {
      setPublishStep(1);
      setTimeout(function () {
        return setPublishStep(0);
      }, 5000);
    } else {
      runDeployAction(PUBLISHING, null, onDeploySuccess);
    }
  };
  useEffect(function () {
    setWebAppBtnStatus();
    setPublishBtnStatus();
    if (!siteInfo) return;
    if (siteInfo.StatusLock === LOCK_STATUS.LOCKED) {
      setMessage('Site is locked. Go to Contentful to unlock.');
      return;
    }
    if (process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.WIP && !siteInfo.HasWIP) {
      setMessage('WIP site not found. Create a WIP version in the Contentful Website Record first.');
    } else if (process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.STAGE && !siteInfo.HasStaging) {
      setMessage('Staging site not found. Create a stage version in the Contentful Website Record first.');
    } else {
      setMessage('');
    }
  }, [siteInfo]);
  var setWebAppBtnStatus = function setWebAppBtnStatus() {
    if (!siteInfo) {
      setWebAppBtnDisabled(true);
      return;
    }
    if (siteInfo.StatusLock === LOCK_STATUS.LOCKED) {
      setWebAppBtnDisabled(true);
      return;
    }
    if (process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.WIP) {
      if (!siteInfo.HasWIP) {
        setWebAppBtnDisabled(true);
        return;
      }
    }
    if (process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.STAGE) {
      if (!siteInfo.HasStaging) {
        setWebAppBtnDisabled(true);
        return;
      }
    }
    setWebAppBtnDisabled(false);
  };
  var setPublishBtnStatus = function setPublishBtnStatus() {
    if (!siteInfo) {
      setPublishBtnDisabled(true);
      return;
    }
    if (siteInfo.StatusLock === LOCK_STATUS.LOCKED) {
      setPublishBtnDisabled(true);
      return;
    }
    setPublishBtnDisabled(false);
  };
  var cancelScheduleOnSuccess = function cancelScheduleOnSuccess() {
    setMessage('Schedule cancelled successfully');
    setError(false);
  };
  var cancelScheduleOnFail = function cancelScheduleOnFail(_ref3) {
    var message = _ref3.message;
    setMessage("Error while trying to cancel the schedule - ".concat(message));
    setError(true);
  };
  return __jsx("div", {
    className: "nva-instant-preview__deploy-wrapper"
  }, __jsx("div", {
    className: "nva-instant-preview__deploy"
  }, __jsx("p", {
    className: "nva-instant-preview__env"
  }, process.env.NEXT_PUBLIC_INSTANT_PREVIEW_ENV), process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.WIP && __jsx("p", {
    className: "nva-instant-preview__env"
  }, INSTANT_PREVIEW_VERSION.WIP), (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.URL) && __jsx("a", {
    className: "nva-instant-preview__deploy-link",
    href: prependHttp(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.URL),
    target: "blank",
    title: prependHttp(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.URL)
  }, "Go to site", __jsx(Icon, {
    name: "open-in-new",
    size: 16
  })), process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.STAGE && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.HasStaging) && __jsx("a", {
    className: "nva-instant-preview__deploy-link",
    href: prependHttp(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.StagingURL),
    target: "blank",
    title: prependHttp(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.StagingURL)
  }, "Go to stage site", __jsx(Icon, {
    name: "open-in-new",
    size: 16
  })), process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.WIP && (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.HasWIP) && __jsx("a", {
    className: "nva-instant-preview__deploy-link",
    href: prependHttp(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.WipURL),
    target: "blank",
    title: prependHttp(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo.WipURL)
  }, "Go to WIP site", __jsx(Icon, {
    name: "open-in-new",
    size: 16
  })), __jsx("div", {
    className: "nva-instant-preview__deploy-buttons"
  }, __jsx("div", {
    className: "nva-instant-preview__deploy-buttons-wrapper"
  }, __jsx("div", {
    className: "nva-instant-preview-v2__deploy-button-group"
  }, __jsx("button", {
    className: "nva-instant-preview__button ".concat(stateClasses.revalidate),
    onClick: function onClick() {
      return runDeployAction(REVALIDATE_PATH, null, onDeploySuccess);
    },
    title: "Regenarate page to see the new content (ISR)",
    disabled: webAppBtnDisabled,
    type: "button"
  }, __jsx(Icon, {
    name: "revalidate"
  }), "Update Page")), (process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.WIP || process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.STAGE) && __jsx("div", {
    className: "nva-instant-preview-v2__deploy-button-group"
  }, __jsx("button", {
    className: "nva-instant-preview__button ".concat(stateClasses.staging),
    onClick: function onClick() {
      return runDeployAction(STAGING, null, onDeploySuccess);
    },
    title: "Create stage site.",
    disabled: webAppBtnDisabled,
    type: "button"
  }, __jsx(Icon, {
    name: "stage"
  }), "Update Site")), process.env.NEXT_PUBLIC_INSTANT_PREVIEW_VERSION === INSTANT_PREVIEW_VERSION.STAGE && __jsx("div", {
    className: "nva-instant-preview-v2__deploy-button-group"
  }, __jsx("button", {
    className: "nva-instant-preview__button ".concat(stateClasses.publishing),
    onClick: handlePublishClick,
    title: "Publish changes to production site.",
    disabled: publishBtnDisabled,
    type: "button"
  }, __jsx(Icon, {
    name: "publish"
  }), publishStep === 0 ? 'Publish Site' : 'Click again to confirm'), __jsx("button", {
    className: "nva-instant-preview__button",
    onClick: function onClick() {
      setIsPublishOpen(!isPublishOpen);
      setIsSyncOpen(false);
      setIsRevalidateOpen(false);
      setIsStageOpen(false);
    },
    title: "Schedule publish changes to production site.",
    disabled: (scheduledPublishing === null || scheduledPublishing === void 0 ? void 0 : scheduledPublishing.length) > 0 || publishBtnDisabled,
    type: "button"
  }, __jsx(Icon, {
    name: "schedule"
  })), __jsx(ScheduleDialog, {
    action: PUBLISHING_SCHEDULED,
    stateClasses: stateClasses,
    isOpen: isPublishOpen,
    setIsOpen: setIsPublishOpen,
    runDeployAction: runDeployAction,
    setScheduled: setScheduledPublishing
  }))))), message && __jsx("p", {
    className: "nva-instant-preview__deploy-status ".concat(error ? 'is-error' : '')
  }, message), (scheduledPublishing === null || scheduledPublishing === void 0 ? void 0 : (_scheduledPublishing$ = scheduledPublishing[0]) === null || _scheduledPublishing$ === void 0 ? void 0 : _scheduledPublishing$.TriggeredAt) && __jsx("div", {
    className: "nva-instant-preview__info"
  }, __jsx("table", null, __jsx("thead", null, __jsx("tr", null, __jsx("th", null), __jsx("th", null, "Scheduled"))), __jsx("tbody", null, __jsx("tr", null, __jsx("th", null, "Publishing:"), __jsx("td", null, __jsx("ul", null, __jsx("li", null, parseDateTime(scheduledPublishing === null || scheduledPublishing === void 0 ? void 0 : (_scheduledPublishing$2 = scheduledPublishing[0]) === null || _scheduledPublishing$2 === void 0 ? void 0 : _scheduledPublishing$2.TriggeredAt), __jsx("button", {
    className: "nva-instant-preview__button",
    type: "button",
    onClick: function onClick() {
      var _scheduledPublishing$3;
      return cancelSchedule({
        id: scheduledPublishing === null || scheduledPublishing === void 0 ? void 0 : (_scheduledPublishing$3 = scheduledPublishing[0]) === null || _scheduledPublishing$3 === void 0 ? void 0 : _scheduledPublishing$3.Id,
        setScheduled: setScheduledPublishing,
        onSuccess: cancelScheduleOnSuccess,
        onFail: cancelScheduleOnFail
      });
    },
    disabled: publishBtnDisabled
  }, __jsx(Icon, {
    name: "delete",
    size: 16
  }))))))))), loading && __jsx("p", null, "Loading..."));
}
export default DeployControlsV2;